import React from 'react';

// import axios from 'axios';
import { setSnackbarMessage } from 'actions/snackbar';
import client from 'core/axios';
import addErrorSnackbarInterceptors from 'core/axios/interceptors/addErrorSnackbarInterceptors';

// https://medium.com/neyasistechnology/react-handling-errors-with-axios-interceptor-and-redux-6e523fda3706
const connectStoreToAxiosInterceptors = store => {
  // When moving the snackbar into addErrorSnackbarInterceptors will cause error:
  // Objects are not valid as a React child (found: object with keys {detail}).
  // If you meant to render a collection of children, use an array instead.
  const checkAndSendSnackbarError = error => {
    // Disable network error snackbar due to it's still showing for
    // axios Cancelled request -> not real error for some user on production
    // if (error.response === undefined && !axios.isCancel(error)) {
    //   store.dispatch(
    //     setSnackbarMessage({
    //       variant: 'error',
    //       message: <span>There was a network error. Please try again.</span>,
    //     }),
    //   );
    // }

    if (error?.response?.status === 500) {
      store.dispatch(
        setSnackbarMessage({
          variant: 'error',
          message: (
            <span>
              Oops, something went wrong. <br />
              Our team has been notified and we&apos;re looking into the issue!
            </span>
          ),
        }),
      );
    }
    if (error?.response?.status === 429) {
      store.dispatch(
        setSnackbarMessage({
          variant: 'error',
          message: (
            <span>
              {typeof error?.response?.data?.detail === 'string'
                ? error?.response?.data?.detail
                : 'Whoa you are moving way too fast here, please wait a bit to continue'}
            </span>
          ),
        }),
      );
    }
  };

  addErrorSnackbarInterceptors(client, checkAndSendSnackbarError);
};

export default connectStoreToAxiosInterceptors;
